interface TelegramConnectionButtonLabelInput {
  checkingLabel: string;
  connecting: boolean;
  connectingLabel: string;
  defaultLabel: string;
  loading: boolean;
  recoveringLabel: string;
  recoveringPermission: boolean;
}

/** Resolves the visible Telegram CTA label for loading and permission states. */
export function getTelegramConnectionButtonLabel({
  checkingLabel,
  connecting,
  connectingLabel,
  defaultLabel,
  loading,
  recoveringLabel,
  recoveringPermission,
}: TelegramConnectionButtonLabelInput) {
  if (loading) return checkingLabel;
  if (connecting) return connectingLabel;
  if (recoveringPermission) return recoveringLabel;
  return defaultLabel;
}
